import type { InjectionKey } from 'vue';

export type PageHeadingLevel = 'h1' | 'h2';

// A shell that renders the layout's title provides 'h2' so a page-header inside it is a section heading.
export const PAGE_HEADING_LEVEL: InjectionKey<PageHeadingLevel> = Symbol('pageHeadingLevel');
